import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os dados por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/74/equipe/${nu_ine}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os dados por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getDadosPorMicroarea(cod_ibge, nu_ine, microarea) {
  try {
    const { data } = await api.get(
      `/app/vacina-idade-certa/${cod_ibge}/vacina/74/equipe/${nu_ine}/micro-area/${microarea}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function formatarCadastrosComDoses(cadastros) {
  const data = cadastros.map((item, index) => {
    const vacinasPendentes = JSON.parse(item.vacinas_pendentes)
    const vacinasAplicadas = JSON.parse(item.vacinas_aplicadas)

    const coresAcwy = [
      {
        dose: 'DOSE',
        cor: 'white',
        dt_aplicacao_br: '',
      },
      {
        dose: 'REFORÇO',
        cor: 'white',
        dt_aplicacao_br: '',
      },
    ]
    const doseAcwy = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '74',
      '8'
    )
    const reforcoAcwy = encontrarDose(
      vacinasPendentes,
      vacinasAplicadas,
      '74',
      '38'
    )

    if (doseAcwy.tipo == 'aplicada') {
      coresAcwy[0].cor = 'green'
      coresAcwy[0].dt_aplicacao_br = doseAcwy.dt_aplicacao_br
      coresAcwy[0].dose_anterior = doseAcwy.dose_anterior
    } else {
      coresAcwy[0].cor = doseAcwy.cor
      coresAcwy[0].dt_aplicacao_br = '11 a 14 anos'
      coresAcwy[0].sg_d = doseAcwy.sg_d
      coresAcwy[0].sg_im = doseAcwy.sg_im
    }

    if (reforcoAcwy.tipo == 'aplicada') {
      coresAcwy[1].cor = 'green'
      coresAcwy[1].dt_aplicacao_br = reforcoAcwy.dt_aplicacao_br
      coresAcwy[1].dose_anterior = reforcoAcwy.dose_anterior
    } else {
      coresAcwy[1].cor = reforcoAcwy.cor
      coresAcwy[1].dt_aplicacao_br = '11 a 14 anos'
      coresAcwy[1].sg_d = reforcoAcwy.sg_d
      coresAcwy[1].sg_im = reforcoAcwy.sg_im
    }

    return {
      index: index,
      ...item,
      coresAcwy,
    }
  })
  return data
}

function encontrarDose(vacinasPendentes, vacinasAplicadas, id_im, id_d) {
  if (vacinasPendentes != null) {
    const dosePendente = vacinasPendentes.find(
      (el) => el.id_im == Number(id_im) && el.id_d == Number(id_d)
    )
    if (dosePendente !== undefined) {
      return {
        tipo: 'pendente',
        cor: 'red',
        dt_aplicacao_br: '',
        sg_d: dosePendente.sg_d,
        sg_im: dosePendente.sg_im,
      }
    }
  }
  if (vacinasAplicadas != null) {
    const doseAplicada = vacinasAplicadas.find(
      (el) => el.id_imuno == id_im && el.id_dose_imuno == id_d
    )
    if (doseAplicada !== undefined) {
      return {
        tipo: 'aplicada',
        dt_aplicacao: doseAplicada.dt_aplicacao,
        dt_aplicacao_br: doseAplicada.dt_aplicacao_br,
        dose_anterior: doseAplicada.dose_anterior,
        id_dose_imuno: doseAplicada.id_dose_imuno,
      }
    }
  }
  return {
    tipo: 'pendente',
    cor: 'white',
    dt_aplicacao_br: '',
    sg_d: '',
    sg_im: '',
  }
}

export function exibirVermelhos(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (item.coresAcwy.find((element) => element.cor === 'red')) {
      return true
    }
  })
  return filtro
}

export function exibirVerdes(cadastros) {
  const cadastrosFormatados = formatarCadastrosComDoses(cadastros)
  const filtro = cadastrosFormatados.filter((item) => {
    if (
      item.coresAcwy.every(
        (element) => element.cor === 'green' || element.cor === 'white'
      )
    ) {
      return true
    }
  })
  return filtro
}

export function filterSituacao(data, situacao) {
  let filtrado = data.filter((item) => {
    let idade = Number(item.idade_anos)
    if (situacao === 'Todos') {
      return item
    }
    if (situacao === '11 - 12 anos') {
      return idade === 11 || idade == 12
    } else if (situacao === '13 - 14 anos') {
      return idade === 13 || idade == 14
    } else {
      return item
    }
  })
  return filtrado
}

export function generatePdf(cadastros, selectEquipe, microArea) {
  const titlePdf = 'Meningocócica ACWY'
  const titlePdfSave = utils.methods.titlePdf(titlePdf, selectEquipe.no_equipe)
  const descriptionPdf = 'Situação vacinal de pessoas com meningocócica ACWY'
  const headersPdf = ['NOME', 'NASCIMENTO', 'MÃE', 'MA', 'ACWY', 'DOCUMENTO']

  const doses = formatarCadastrosComDoses(cadastros)
  const dataPdf = doses.map((item, index) => {
    const documentos = []
    if (cadastros[index]?.nu_cpf)
      documentos.push(`CPF ${cadastros[index].nu_cpf}`)
    if (cadastros[index]?.nu_cns)
      documentos.push(`CNS ${cadastros[index].nu_cns}`)

    return {
      no_cidadao: item.no_cidadao,
      dt_nascimento: utils.methods.formatDate(item.dt_nascimento),
      no_mae: item.no_mae,
      ma: item.micro_area,
      acwy: item.coresAcwy
        .map((d) => `${d.dose} - ${d.dt_aplicacao_br}`)
        .join('\n'),
      documento: documentos.join('\n'),
    }
  })

  const doc = new jsPDF(utils.methods.encryptionPdf())
  const table = utils.methods.createTablePdf(dataPdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64Brasao) => {
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64Brasao,
        titlePdf,
        descriptionPdf
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          { label: 'Equipe', value: selectEquipe.no_equipe },
          { label: 'CNES', value: selectEquipe.nu_cnes },
          { label: 'INE', value: selectEquipe.nu_ine },
          { label: 'Microárea', value: microArea },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headersPdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: ({ row }) => {
          if (row.section === 'head') doc.setTextColor(0, 0, 0)
        },
      })

      utils.methods.footerPdf(doc, doc.autoTable.previous.finalY)
      doc.save(`${titlePdfSave}.pdf`)

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const dataFields = {
  Nome: 'no_cidadao',
  Nascimento: {
    field: 'dt_nascimento',
    callback: (value) => {
      return value !== null ? utils.methods.formatDate(value) : ''
    },
  },
  Mãe: 'no_mae',
  MA: 'micro_area',
}
